/**
 * When enabled, allow MFA result to be returned in login-data request (email, but not password).
 * Tech design: https:docs.google.com/document/d/1cqfkSwVA-zFXzeVDmConYM9dvNqt-XxQWs_41b4v7D0/edit
 * @deprecated Remove after FE/mobile usage removed
 */ export var ENABLE_MFA_TIMING_XP_241018 = 'ENABLE_MFA_TIMING_XP_241018';
